document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('ppp-modal');
  const modalImage = modal && modal.querySelector('.ppp-modal-img');
  const closeButton = modal && modal.querySelector('.ppp-modal-close');
  const triggers = Array.from(document.querySelectorAll('img.ppp-modal-trigger'));
  if (!modal || !modalImage || !closeButton || !triggers.length) return;

  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', modalImage.alt || triggers[0].alt);
  modal.setAttribute('aria-hidden', 'true');
  closeButton.setAttribute('aria-label', theme.strings.accessibilityClose);
  closeButton.setAttribute('type', 'button');
  let activeTrigger;
  let previousOverflow;
  let isOpen = false;

  const close = () => {
    modal.classList.remove('ppp-open');
    modal.setAttribute('aria-hidden', 'true');
    if (isOpen) {
      isOpen = false;
      document.body.style.overflow = previousOverflow;
      removeTrapFocus(activeTrigger);
    }
  };

  triggers.forEach((image) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ppp-accessible-trigger';
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', modal.id);
    button.setAttribute('aria-label', `${theme.strings.accessibilityViewDetails}: ${image.alt}`);
    image.before(button);
    button.append(image);
    button.addEventListener('click', (event) => {
      event.preventDefault();
      activeTrigger = button;
      modalImage.src = image.dataset.full || image.src;
      document.body.append(modal);
      modal.classList.add('ppp-open');
      modal.setAttribute('aria-hidden', 'false');
      if (!isOpen) previousOverflow = document.body.style.overflow;
      isOpen = true;
      document.body.style.overflow = 'hidden';
      trapFocus(modal, closeButton);
    });
  });

  closeButton.addEventListener('click', close);
  modal.addEventListener('click', (event) => {
    if (event.target === modal) close();
  });
  document.addEventListener('keydown', (event) => {
    if (isOpen && event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
    }
  }, true);
});
